

export const FILTER_TAG_ID_SEPARATOR = "T:01"

